import React from "react";
import "./index.css";

export default function App() {
  return (
    <div>
      <header
        style={{
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1
          style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#4f46e5" }}
        >
          Linhiev Technologies
        </h1>
        <nav style={{ display: "flex", gap: "1rem" }}>
          <a href="#services">Services</a>
          <a href="#work">Work</a>
          <a href="#pricing">Pricing</a>
          <a
            href="#contact"
            style={{
              background: "#4f46e5",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "5px",
            }}
          >
            Contact
          </a>
        </nav>
      </header>

      <main
        style={{ maxWidth: "900px", margin: "2rem auto", padding: "0 1rem" }}
      >
        <section style={{ marginBottom: "3rem" }}>
          <h2 style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Build faster. Scale smarter.
          </h2>
          <p style={{ marginTop: "1rem", color: "#555" }}>
            Linhiev Technologies delivers mobile apps, web experiences, reliable
            hosting and cloud solutions that grow with your business.
          </p>
        </section>

        <section id="services" style={{ marginBottom: "3rem" }}>
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Our Services
          </h3>
          <ul style={{ marginTop: "1rem", lineHeight: "1.8" }}>
            <li>📱 Mobile Development</li>
            <li>💻 Web Development</li>
            <li>🌐 Web Hosting</li>
            <li>☁️ Cloud Computing</li>
          </ul>
        </section>

        <section id="contact" style={{ marginBottom: "3rem" }}>
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Get in Touch
          </h3>
          <p>
            Email: <a href="mailto:hello@linhiew.tech">info@linhiev.com</a>
          </p>
          <p>Phone: +254 727 914 288</p>
        </section>
      </main>

      <footer
        style={{ textAlign: "center", padding: "1rem", background: "#f3f4f6" }}
      >
        © {new Date().getFullYear()} Linhiev Technologies
      </footer>
    </div>
  );
}
